<template>
  <div class="collapseList">
    <el-collapse v-model="activeValue" @change="collapseClick">
      <el-collapse-item v-for="collapse in collapseData" :name="collapse.name" :key="collapse.name">
        <div slot="title" class="collapse-title">{{ collapse.title }}</div>
        <slot :name="collapse.name">{{ collapse.name }}</slot>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "Collapse",
  data() {
    return {
      activeValue: this.active
    }
  },
  props: {
    active: {
      type: Array
    },
    collapseData: {
      type: Array,
    }
  },
  methods: {
    collapseClick(activeValue) {
      this.$emit("update:active", activeValue)
    }
  },
  watch: {
    active(newVal) {
      this.activeValue = newVal;
    },
    activeValue(newVal, oldVal) {
      this.$emit("update:active", newVal);
    },
  },
}
</script>
<style scoped>
.collapseList ::v-deep .el-collapse {
  border: none;
}

.collapseList .collapse-title {
  font-size: var(--subTitle-font-size);
  line-height: var(--subTitle-line-height);
  display: flex;
  order: 2;
  width: 100%;
  font-weight: bold;
}

.collapseList ::v-deep .el-collapse-item__wrap {
  border: none;
}

/* modify icon arrow rotate and float left */
.collapseList ::v-deep .el-collapse-item__arrow {
  transform: rotate(90deg);
  display: flex;
  order: 1;
  transition: none;
}

/* modify active icon arrow rotate */
.collapseList ::v-deep .el-collapse-item__arrow.is-active {
  transform: rotate(270deg);
}

.collapseList ::v-deep .el-collapse-item__header {
  border: none;
}

.collapseList ::v-deep .el-collapse-item__header,
.collapseList ::v-deep .el-collapse-item__wrap {
  background: transparent;
}
</style>
